<template>
    <div>
        <div class="card card-box mb-3">
            <div class="card-body p-4">
                <h5 class="font-weight-bold">Tanda-Tanda Vital</h5>
                <b-row>
                    <b-col md="6" lg="6">
                        <div class="form-group row mb-header">
                            <label for="staticEmail" class="col-sm-4 col-form-label font-weight-bold">Tinggi Badan</label>
                            <div class="col-sm-8 form-control-plaintext">
                                : {{ dataRM.anamnesa.tinggi_badan ? dataRM.anamnesa.tinggi_badan : '-' }} cm
                            </div>
                        </div>
                        <div class="form-group row mb-header">
                            <label for="staticEmail" class="col-sm-4 col-form-label font-weight-bold">Berat Badan</label>
                            <div class="col-sm-8 form-control-plaintext">
                                : {{ dataRM.anamnesa.berat_badan ? dataRM.anamnesa.berat_badan : '-' }} kg
                            </div>
                        </div>
                        <div class="form-group row mb-header">
                            <label for="staticEmail" class="col-sm-4 col-form-label font-weight-bold">Suhu</label>
                            <div class="col-sm-8 form-control-plaintext">
                                : {{ dataRM.anamnesa.suhu ? dataRM.anamnesa.suhu : '-' }} c
                            </div>
                        </div>
                        <div class="form-group row mb-header">
                            <label for="staticEmail" class="col-sm-4 col-form-label font-weight-bold">Sistole</label>
                            <div class="col-sm-8 form-control-plaintext">
                                : {{ dataRM.anamnesa.tensi_sistole ? dataRM.anamnesa.tensi_sistole : '-' }} mmHg
                            </div>
                        </div>
                        <div class="form-group row mb-header">
                            <label for="staticEmail" class="col-sm-4 col-form-label font-weight-bold">Diastole</label>
                            <div class="col-sm-8 form-control-plaintext">
                                : {{ dataRM.anamnesa.tensi_diastole ? dataRM.anamnesa.tensi_diastole : '-' }} mmHg
                            </div>
                        </div>
                    </b-col>
                    <b-col md="6" lg="6">
                        <div class="form-group row mb-header">
                            <label for="staticEmail" class="col-sm-4 col-form-label font-weight-bold">Nadi</label>
                            <div class="col-sm-8 form-control-plaintext">
                                : {{ dataRM.anamnesa.nadi ? dataRM.anamnesa.nadi : '-' }} x/menit
                            </div>
                        </div>
                        <div class="form-group row mb-header">
                            <label for="staticEmail" class="col-sm-4 col-form-label font-weight-bold">Respirasi</label>
                            <div class="col-sm-8 form-control-plaintext">
                                : {{ dataRM.anamnesa.respirasi ? dataRM.anamnesa.respirasi : '-' }} x/menit
                            </div>
                        </div>
                        <div class="form-group row mb-header">
                            <label for="staticEmail" class="col-sm-4 col-form-label font-weight-bold">Lingkar Perut</label>
                            <div class="col-sm-8 form-control-plaintext">
                                : {{ dataRM.anamnesa.lingkar_perut ? dataRM.anamnesa.lingkar_perut : '-' }} cm
                            </div>
                        </div>
                        <div class="form-group row mb-header">
                            <label for="staticEmail" class="col-sm-4 col-form-label font-weight-bold">IMT</label>
                            <div class="col-sm-8 form-control-plaintext">
                                : {{ dataRM.anamnesa.imt ? dataRM.anamnesa.imt : '-' }} kg/m2
                            </div>
                        </div>
                        <div class="form-group row mb-header">
                            <label for="staticEmail" class="col-sm-4 col-form-label font-weight-bold">Saturasi Oksigen</label>
                            <div class="col-sm-8 form-control-plaintext">
                                : {{ dataRM.anamnesa.saturasi_oksigen ? dataRM.anamnesa.saturasi_oksigen : '-' }} %
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </div>
        <div class="card card-box mb-3">
            <div class="card-body p-4">
                <h5 class="font-weight-bold">Anamnesis</h5>
                <b-row class="mt-3">
                    <b-col md="12" lg="12">
                        <div v-html="dataRM.anamnesa.notes"></div>
                        <template v-if="dataRM.anamnesa.draw_path !== null">
                            <img :src="dataRM.anamnesa.draw_path" class="img-fluid" alt="img" />
                        </template>
                    </b-col>
                </b-row>
            </div>
        </div>
        <div class="card card-box mb-3" v-if="poliGigi">
            <div class="card-body p-4">
                <h5 class="font-weight-bold">Riwayat Kesehatan</h5>
                <div class="row">
                    <label class="col-sm-6 col-md-3 col-form-label font-weight-bold">Penyakit Jantung</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        {{ convertData(dataRM.diagnosa.penyakit_jantung) }}
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-6 col-md-3 col-form-label font-weight-bold">Diabetes</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        {{ convertData(dataRM.diagnosa.diabetes) }}
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-6 col-md-3 col-form-label font-weight-bold">Haemopilia</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        {{ convertData(dataRM.diagnosa.haemopilia) }}
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-6 col-md-3 col-form-label font-weight-bold">Hepatitis</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        {{ convertData(dataRM.diagnosa.hepatitis) }}
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-6 col-md-3 col-form-label font-weight-bold">Gastring</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        {{ convertData(dataRM.diagnosa.gastring) }}
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-6 col-md-3 col-form-label font-weight-bold">Riwayat Pengobatan</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        {{ convertData(dataRM.diagnosa.penyakit_lainnya, dataRM.diagnosa.ket_penyakit_lainnya) }}
                    </div>
                </div>
            </div>
        </div>
        <div class="card card-box mb-3">
            <div class="card-body p-4">
                <h5 class="font-weight-bold">Alergi & Kondisi Khusus</h5>
                <div class="row">
                    <label class="col-sm-6 col-md-3 col-form-label font-weight-bold">Riwayat Penyakit</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        {{ dataRM.anamnesa.riwayat_penyakit || '-' }}
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-6 col-md-3 col-form-label font-weight-bold">Riwayat Alergi Obat</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        {{ dataRM.anamnesa.riwayat_alergi_obat || '-' }}
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-6 col-md-3 col-form-label font-weight-bold">Riwayat Alergi Makanan</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        {{ dataRM.anamnesa.riwayat_alergi_makanan || '-' }}
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-6 col-md-3 col-form-label font-weight-bold">Riwayat Alergi Udara</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        {{ dataRM.anamnesa.riwayat_alergi_udara || '-' }}
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-6 col-md-3 col-form-label font-weight-bold">Riwayat Alergi Lain-lain</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        {{ dataRM.anamnesa.riwayat_alergi_lain || '-' }}
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-6 col-md-3 col-form-label font-weight-bold">Riwayat Pengobatan</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        {{ dataRM.anamnesa.riwayat_pengobatan || '-' }}
                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-6 col-md-3 col-form-label font-weight-bold">Keterangan Lain</label>
                    <div class="col-sm-6 col-md-9 form-control-plaintext">
                        <div v-html="dataPasien.keterangan_lain || '-'"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Poliklinik",
    props: ["dataRM", "dataPasien", "poliGigi"],
    data() {
        return {
        }
    },
    watch: {
    },
    methods: {
        convertData(status, content = null) {
            if (status == 'T') {
                return 'Tidak Ada';
            }
            if (status == 'Y') {
                if (content) return `Ada, ${content}`;
                else return 'Ada';
            }
            return '-';
        },
    }
}
</script>

<style>
.mb-header {
    margin-bottom: -15px;
}
</style>